'use client';

import React from 'react';

import { TasticProps } from 'frontastic/tastics/types';


import PrivacyPage from 'components/commercetools-ui/organisms/content/privacy-page';

export interface ExperienceCenterLocationSpecificProps {
  data: any;
}
const PrivacyPageTastic = ({ data }: TasticProps<ExperienceCenterLocationSpecificProps>) => {
  return <PrivacyPage data={data?.data?.dataSource} />;
};

export default PrivacyPageTastic;
